import { createSlice } from "@reduxjs/toolkit";
import { IGetTariffsResponse } from "store/api/types";

const initialState: IGetTariffsResponse[] = [];

export const tariffsSlice = createSlice({
  name: "tariffs",
  initialState,
  reducers: {
    setTariffs: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setTariffs } = tariffsSlice.actions;
export default tariffsSlice.reducer;
